// Patient Management System Page (1st Page)

import { useState, useMemo, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "./PatientForm.css";
import {
  faEye,
  faEyeSlash,
  faStar as solidStar,
} from "@fortawesome/free-solid-svg-icons";
import { faStar as regularStar } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import BasicDatePicker from "./Date-picker";
import {
  calculateAgeInMonths,
  caluclateAgeinDays,
  caluclateGestationalAgeInDays,
  getDateAndYear,
} from "../helper/getAge";

import {
  antenatalCheckUpsvalues,
  antenatalIllnessOptionValues,
  breastFeedingValues,
  criedAtBirthValues,
  gendersValue,
  hospitalizationValues,
  immunizationValue,
  injectionTetanusToxoidValues,
  ironValues,
  maternalEducationValues,
  modeOfDeliveryvalues,
  mothersNutritionValues,
  neonatalProblemsOptionValues,
  placeOfDeliveryValues,
  relationValues,
  resuscitationValues,
  yesNoOptions,
} from "./selectOptionValues";
import { toast } from "react-toastify";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import NumberInput from "./ui/NumberInput";
import Loader from "./Loader";
import capitailzer, { cleanEnglishOnly } from "../util/capitalize";
import CountdownMessage from "./CountDown";
import axios from "axios";
import { languages } from "../locals/languageCode";
import { useParentContext } from "../context/ParentContext";

const ParentAddChildForm = () => {
  const { handleLanguageChange, language } = useParentContext()
  const { docId: pediatricianId, childId, parentId } = useParams();
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] =
    useState(false);
  const location = useLocation();
  const { doctorId, dob } = location.state || {};

  const PATIENTFORM = {
    CAREGIVER: 0,
    PATIENT: 1,
    MATERNAL: 2,
    ANTENATAL: 3,
    BIRTH: 4,
    NEONATAL: 5,
    FAMILY: 6,
    FEEDING: 7,
    PRESENT: 8,
    SURVEY: 9,
  };
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
        overflowY: "auto",
      },
    },
  };

  const CAREGIVERSTATE = {
    caregiverFirstName: "",
    caregiverLastName: "",
    relationship: "",
    phoneNumber: "",
    email: "",
    address: "",
    password: "",
    confirmPassword: "",
  };

  const PATIENTSTATE = {
    patientFirstName: "",
    patientMiddleName: "",
    patientLastName: "",
    dateOfBirth: null,
    gender: "",
  };

  const MATERNALSTATE = {
    maternalAge: "",
    education: "",
    numberOfChildren: "",
  };

  const ANTENATALSTATE = {
    mothersNutrition: "",
    antenatalCheckUps: "",
    iron: "",
    injectionTetanusToxoid: "",
    antenatalIllness: [],
    edd: null,
  };

  const BIRTHSTATE = {
    placeOfDelivery: "",
    modeOfDelivery: "",
    criedAtBirth: "",
    resuscitation: [],
    congenitalAnomaly: "",
    birthTrauma: "",
    others: "",
    birthWeight: "",
    birthLength: "",
    birthHeadCircumference: "",
    gestationalAge: "",
  };

  const NEONATALSTATE = {
    neonatalProblems: [],
    hospitalization: "",
  };

  const PRESENTSTATE = {
    presentNutrition: "",
    immunization: "",
    chronicIllness: "",
    growthFaltering: "",
    delayedDevelopmentMotor: "",
    delayedDevelopmentCognitive: "",
    delayedDevelopmentLanguage: "",
    atypicalBehaviour: "",
    convulsions: "",
    dysmorphism: "",
    anySystemicIllness: "",
    currentAge: "",
    currentWeight: "",
    currentLength: "",
    currentHeadCircumference: "",
    presentOthers: "",
    currentAgeInDays: "",
    gestationalAgeInMonths: "",
    gestationalAgeInDays: "",
  };

  const TOGGLESTATE = {
    isCongenitalAnomaly: false,
    chronicIllness: false,
    growthFaltering: false,
    delayedDevelopmentMotor: false,
    delayedDevelopmentCognitiveSocial: false,
    delayedDevelopmentLanguage: false,
    atypicalBehaviour: false,
    dysmorphism: false,
    anySystemicIllness: false,
    anyHistoryofIllness: false,
    disabilityInTheFamily: false,
    anyBehaviouralProblem: false,
    birthTrauma: false,
  };

  const FAMILYSTATE = {
    anyHistoryofIllness: "",
    disabilityInTheFamily: "",
    anyBehaviouralProblem: "",
  };

  const FEEDINGSTATE = {
    breastFeeding: "",
    solidFood: "",
    noOfFeeds: "",
  };

  const SURVEYSTATE = {
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
  };

  const intialFormScreen =
    childId && parentId ? PATIENTFORM.MATERNAL : PATIENTFORM.CAREGIVER;

  const [step, setStep] = useState(intialFormScreen);
  const [cargiver, setCaregiver] = useState(CAREGIVERSTATE);
  const [patient, setPatient] = useState(PATIENTSTATE);
  const [maternal, setMaternal] = useState(MATERNALSTATE);
  const [antenatal, setAntenatal] = useState(ANTENATALSTATE);
  const [birth, setBirth] = useState(BIRTHSTATE);
  const [neontal, setNeonatal] = useState(NEONATALSTATE);
  const [toggle, setToggle] = useState(TOGGLESTATE);
  const [present, setPresent] = useState(PRESENTSTATE);
  const [family, setFamily] = useState(FAMILYSTATE);
  const [feeding, setFeeding] = useState(FEEDINGSTATE);
  const [isChildAdded, setIsChildAdded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [haveAccount, setHaveAccount] = useState(false);
  const [accountVerified, setAccountVerified] = useState(false);
  const [accountVerifingLoading, setAccountVerifingLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [survey, setSurvey] = useState(SURVEYSTATE);
  const navigate = useNavigate();
  const BackendURL = process.env.REACT_APP_BACKEND_URL;
  // const secretKey = process.env.REACT_APP_CRYPTO_SECRET
  //    console.log(secretKey,'secretKey')

  // Handle date change for Date Picker
  useEffect(() => {
    const gestationalWeeks = birth.gestationalAge;
    const actualAgeInDays = caluclateAgeinDays(patient.dateOfBirth);
    const adjustedAgeDays = actualAgeInDays - (40 - gestationalWeeks) * 7;
    if (!antenatal?.edd && present.currentAge <= 24) {
      console.log("use effect called");
      if (gestationalWeeks === "") {
        setPresent((prev) => ({
          ...prev,
          gestationalAgeInMonths: "",
          gestationalAgeInDays: "",
        }));
      } else if (gestationalWeeks < 37) {
        const gestMonthsDiff = Math.floor((40 - gestationalWeeks) / 4);
        const gestMonths =
          calculateAgeInMonths(patient.dateOfBirth) - gestMonthsDiff;
        setPresent((prev) => ({
          ...prev,
          gestationalAgeInMonths: gestMonths,
          gestationalAgeInDays: adjustedAgeDays,
        }));
      } else {
        setPresent((prev) => ({
          ...prev,
          gestationalAgeInMonths: present.currentAge,
          gestationalAgeInDays: actualAgeInDays,
        }));
      }
    }
  }, [birth.gestationalAge]);

  useEffect(() => {
    if (!isChildAdded) return;
    const timer = setTimeout(() => {
      navigate("/parent-login");
    }, 10000);
    return () => {
      clearTimeout(timer);
    };
  }, [isChildAdded, navigate]);

  useEffect(() => {
    if (!errorMessage) return;
    setTimeout(() => {
      setErrorMessage("");
    }, 8000);
  }, [errorMessage]);

  useEffect(() => {
    if (!dob || !doctorId) return;
    setPatient((prevData) => ({
      ...prevData,
      dateOfBirth: new Date(dob),
    }));
    const actualAge = caluclateAgeinDays(new Date(dob));
    const actualAgeInMonths = calculateAgeInMonths(new Date(dob));
    if (actualAgeInMonths === 0) {
      setPresent((prevDt) => ({
        ...prevDt,
        currentAgeInDays: actualAge,
        currentAge: actualAgeInMonths,
      }));
    } else {
      setPresent((prevDt) => ({
        ...prevDt,
        currentAge: actualAgeInMonths,
      }));
    }
  }, [dob, doctorId]);

  //checkfor parent already exist or not
  async function checkParentRegistration() {
    try {
      toast.info("Please wait while we are validating your account");
      const res = await axios.get(
        `${BackendURL}/api/check_parent_exist/${cargiver?.phoneNumber}`
      );
      const data = res?.data;
      console.log(data, "checkParentRegistration data");
      if (data?.success) {
        setAccountVerified(true);
        setHaveAccount(true);
        setCaregiver((prev) => ({
          ...prev,
          caregiverFirstName: data?.data?.parent_first_name ?? "",
          caregiverLastName: data?.data?.parent_last_name ?? "",
          address: data?.data?.address ?? "",
          email: data?.data?.parent_email ?? "",
          relationship: data?.data?.relationship ?? "",
        }));
        return true;
      }
    } catch (error) {
      console.log(error, "api error");
      if (error?.response?.status === 404) {
        setAccountVerified(false);
        return false;
      } else {
        setAccountVerified(false);
        return toast.error("Something went wrong, please try again");
      }
    }
  }
  console.log(pediatricianId, childId, parentId, patient.dateOfBirth);
  console.log(accountVerified, "account verified");

  // Handle date change for Date Picker
  const handleDateChange = (date) => {
    setPatient((prevData) => ({
      ...prevData,
      dateOfBirth: date,
    }));
    const actualAge = caluclateAgeinDays(date);
    const actualAgeInMonths = calculateAgeInMonths(date);
    const calculateAgeInDays = caluclateGestationalAgeInDays(
      date,
      antenatal?.edd
    );
    const gestationalAgeInDays =
      getDateAndYear(date) === getDateAndYear(antenatal?.edd)
        ? actualAge
        : calculateAgeInDays !== 0
        ? actualAge - calculateAgeInDays
        : 0;

    if (antenatal.edd) {
      console.log("edd called");
      const eddAgeIndays = caluclateAgeinDays(antenatal.edd);
      const diffWeeks = Math.round((eddAgeIndays - actualAge) / 7);
      const gestWeeks = 40 + diffWeeks;
      setBirth((prev) => ({
        ...prev,
        gestationalAge: gestWeeks,
      }));
      if (actualAgeInMonths <= 24) {
        if (gestWeeks < 37) {
          const gestMonthsDiff = Math.floor((40 - gestWeeks) / 4);
          const gestMonths = actualAgeInMonths - gestMonthsDiff;
          setPresent((prev) => ({
            ...prev,
            gestationalAgeInMonths: gestMonths,
            gestationalAgeInDays: gestationalAgeInDays,
          }));
        } else {
          setPresent((prev) => ({
            ...prev,
            gestationalAgeInMonths: actualAgeInMonths,
            gestationalAgeInDays: actualAge,
          }));
        }
      } else {
        setPresent((prev) => ({
          ...prev,
          gestationalAgeInMonths: "",
          gestationalAgeInDays: "",
        }));
      }
    }
    if (!antenatal?.edd && birth?.gestationalAge) {
      console.log(" gestational called");
      const gestMonthDiff = Math.floor((40 - birth?.gestationalAge) / 4);
      const adjustedAgeMonths = actualAgeInMonths - gestMonthDiff;
      const adjustedAgeDays = actualAge - (40 - birth?.gestationalAge) * 7;
      if (actualAgeInMonths <= 24) {
        if (birth.gestationalAge < 37) {
          console.log(
            "calculated adjusted months new fomula",
            adjustedAgeMonths
          );
          setPresent((prev) => ({
            ...prev,
            gestationalAgeInMonths: adjustedAgeMonths,
            gestationalAgeInDays: adjustedAgeDays,
          }));
        } else {
          setPresent((prev) => ({
            ...prev,
            gestationalAgeInMonths: actualAgeInMonths,
            gestationalAgeInDays: actualAge,
          }));
        }
      } else {
        setPresent((prev) => ({
          ...prev,
          gestationalAgeInMonths: "",
          gestationalAgeInDays: "",
        }));
      }
    }
    if (actualAgeInMonths === 0) {
      return setPresent((prevDt) => ({
        ...prevDt,
        currentAgeInDays: actualAge,
        currentAge: actualAgeInMonths,
      }));
    }
    setPresent((prevDt) => ({
      ...prevDt,
      currentAge: actualAgeInMonths,
    }));
  };

  const handleEddDateChange = (date) => {
    const actualAge = caluclateAgeinDays(patient.dateOfBirth);
    const actualAgeInMonths = calculateAgeInMonths(patient.dateOfBirth);

    const calculateAgeInDays = caluclateGestationalAgeInDays(
      patient.dateOfBirth,
      date
    );

    const gestationalAgeInDays =
      getDateAndYear(date) === getDateAndYear(patient?.dateOfBirth)
        ? actualAge
        : calculateAgeInDays !== 0
        ? actualAge - calculateAgeInDays
        : 0;
    if (date) {
      const eddAgeIndays = caluclateAgeinDays(date);
      console.log("edd age in days", eddAgeIndays);
      console.log("dob age in days", actualAge);
      const diffWeeks = eddAgeIndays
        ? Math.round((eddAgeIndays - actualAge) / 7)
        : "";
      const gestWeeks = 40 + diffWeeks;
      console.log("diffweeks", diffWeeks);
      console.log("gestweeks", gestWeeks);
      setBirth((prev) => ({
        ...prev,
        gestationalAge: gestWeeks,
      }));
      if (present.currentAge <= 24) {
        if (gestWeeks < 37) {
          const gestMonthsDiff = Math.floor((40 - gestWeeks) / 4);
          const gestMonths = actualAgeInMonths - gestMonthsDiff;
          setPresent((prev) => ({
            ...prev,
            gestationalAgeInMonths: gestMonths,
            gestationalAgeInDays: gestationalAgeInDays,
          }));
        } else {
          setPresent((prev) => ({
            ...prev,
            gestationalAgeInMonths: present.currentAge,
            gestationalAgeInDays: actualAge,
          }));
        }
      } else {
        setPresent((prev) => ({
          ...prev,
          gestationalAgeInMonths: "",
          gestationalAgeInDays: "",
        }));
      }
    } else {
      setBirth((prev) => ({
        ...prev,
        gestationalAge: "",
      }));
      setPresent((prev) => ({
        ...prev,
        gestationalAgeInMonths: "",
        gestationalAgeInDays: "",
      }));
    }

    setAntenatal((prevData) => ({
      ...prevData,
      edd: date,
    }));
  };

  function handleAccountChange() {
    setHaveAccount(!haveAccount);
    setAccountVerified(false);
    setAccountVerifingLoading(false);
    setCaregiver((prev) => ({
      ...prev,
      password: "",
      confirmPassword: "",
      email: "",
      caregiverFirstName: "",
      caregiverLastName: "",
      relationship: "",
      address: "",
    }));
  }

  useEffect(() => {
    const parentExist = async () => {
      if (haveAccount && !accountVerified) {
        setAccountVerifingLoading(true);
        const parentExist = await checkParentRegistration();
        setAccountVerifingLoading(false);
        console.log(parentExist, "parent exist");
        if (!parentExist) {
          setErrorMessage(
            "You don't have a Parent account. Please re-enter the Phone number or fill Caregiver information to proceed."
          );
          setHaveAccount(false);
        }
      }
    };
    parentExist();
  }, [haveAccount]);

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zAZ0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email.trim());
  };
  const validatePhoneNumber = (phone) => {
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(phone);
  };

  const handleCaregiverChange = (e) => {
    if (e.target.name === "phoneNumber" && isNaN(e.target.value)) {
      return toast.warn("Phone number must be a positive integer");
    }
    if (e.target.name === "email") {
      setCaregiver({
        ...cargiver,
        [e.target.name]: e.target.value.toLowerCase().trim(),
      });
    } else if (e.target.name === "address") {
      setCaregiver({ ...cargiver, [e.target.name]: cleanEnglishOnly(e.target.value) });
    } else {
      setCaregiver({ ...cargiver, [e.target.name]: cleanEnglishOnly(e.target.value).trim() });
    }
  };

  const handlePatientChange = (e) => {
    if (
      e.target.name === "patientFirstName" ||
      e.target.name === "patientLastName" ||
      e.target.name === "patientMiddleName"
    ) {
      const cleaned = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
      setPatient({ ...patient, [e.target.name]: cleaned.toLowerCase() });
    } else {
      setPatient({ ...patient, [e.target.name]: e.target.value.trim() });
    }
  };

  const handleMaternalChange = (e) => {
    if (e.target.name === "maternalAge" && isNaN(e.target.value)) {
      return toast.warn(`Mother age must be a positive integer`);
    }
    if (e.target.name === "numberOfChildren" && isNaN(e.target.value)) {
      return toast.warn(`Number of children must be a positive integer`);
    }
    setMaternal({ ...maternal, [e.target.name]: cleanEnglishOnly(e.target.value).trim() });
  };

  const handleAntenatalChange = (e) => {
    setAntenatal({ ...antenatal, [e.target.name]: cleanEnglishOnly(e.target.value).trim() });
  };

  const handleBirthChange = (e) => {
    if (e.target.name === "birthWeight" && isNaN(e.target.value)) {
      return toast.warn(`Birth weight must be a positive integer`);
    }
    if (e.target.name === "birthLength" && isNaN(e.target.value)) {
      return toast.warn(`Birth length must be a positive integer`);
    }
    if (e.target.name === "birthHeadCircumference" && isNaN(e.target.value)) {
      return toast.warn(`Birth head circumference must be a positive integer`);
    }
    if (e.target.name === "gestationalAge" && isNaN(e.target.value)) {
      return toast.warn(`Gestational age must be a positive integer`);
    }
    if (e.target.name === "others") {
      return setBirth({ ...birth, [e.target.name]: cleanEnglishOnly(e.target.value) });
    }
    setBirth({ ...birth, [e.target.name]: cleanEnglishOnly(e.target.value).trim() });
  };
  console.log(present);
  const handleNeonatalChange = (e) => {
    setNeonatal({ ...neontal, [e.target.name]: cleanEnglishOnly(e.target.value).trim() });
  };

  const handleFeedingChange = (e) => {
    if (e.target.name === "noOfFeeds" && isNaN(e.target.value)) {
      return toast.warn(`Number of feeds must be a positive integer`);
    }
    setFeeding({ ...feeding, [e.target.name]: cleanEnglishOnly(e.target.value).trim() });
  };

  const handlePresentChange = (e) => {
    // if ((e.target.name === 'currentAge') && Number(e.target.value) < 0) {
    //   return toast.warn(`Current age must be a positive integer`)
    // }
    if (e.target.name === "currentWeight" && isNaN(e.target.value)) {
      return toast.warn(`Current Weight must be a positive integer`);
    }
    if (e.target.name === "currentLength" && isNaN(e.target.value)) {
      return toast.warn(`Current length must be a positive integer`);
    }
    if (e.target.name === "currentHeadCircumference" && isNaN(e.target.value)) {
      return toast.warn(
        `Current head circumference must be a positive integer`
      );
    }
    if (
      e.target.name === "presentOthers" ||
      e.target.name === "atypicalBehaviour"
    ) {
      return setPresent({ ...present, [e.target.name]: cleanEnglishOnly(e.target.value) });
    }
    setPresent({ ...present, [e.target.name]: cleanEnglishOnly(e.target.value).trim() });
  };

  const incrementStep = async () => {
    if (step === PATIENTFORM.CAREGIVER && !validateCaregiverFields()) {
      toast.warn("Please fill all required fields.");
      return;
    }
    if (
      step === PATIENTFORM.CAREGIVER &&
      cargiver?.email &&
      !validateEmail(cargiver.email)
    ) {
      toast.warn("Please enter a valid email address");
      return;
    }
    if (
      step === PATIENTFORM.CAREGIVER &&
      !validatePhoneNumber(cargiver.phoneNumber)
    ) {
      toast.warn("Please enter a valid phone number");
      return;
    }
    if (step === PATIENTFORM.CAREGIVER && haveAccount && !accountVerified) {
      toast.warn(
        "Your account not verified please enter correct phone no. and tick the check box"
      );
      return;
    }
    if (step === PATIENTFORM.CAREGIVER && !accountVerified) {
      const parentExist = await checkParentRegistration();
      if (!haveAccount && parentExist) {
        return setErrorMessage(
          "Parent account already exists for this Phone number. Please proceed to next"
        );
      }
    }
    if (
      step === PATIENTFORM.CAREGIVER &&
      cargiver.password !== cargiver.confirmPassword
    ) {
      toast.warn("Password and Confirm password do not match");
      return;
    }
    if (step === PATIENTFORM.PATIENT && !validatePatientFields()) {
      toast.warn("Please fill all required fields.");
      return;
    }
    if (
      step === PATIENTFORM.BIRTH &&
      toggle.isCongenitalAnomaly &&
      birth.congenitalAnomaly.trim() === ""
    ) {
      return toast.warn("Please specify congenital anomaly");
    }
    if (
      step === PATIENTFORM.BIRTH &&
      toggle.birthTrauma &&
      birth.birthTrauma.trim() === ""
    ) {
      return toast.warn("Please specify birth trauma");
    }
    if (
      step === PATIENTFORM.FAMILY &&
      toggle.anyHistoryofIllness &&
      family.anyHistoryofIllness.trim() === ""
    ) {
      return toast.warn("Please specify any history of illness or death");
    }
    if (
      step === PATIENTFORM.FAMILY &&
      toggle.anyBehaviouralProblem &&
      family.anyBehaviouralProblem.trim() === ""
    ) {
      return toast.warn("Please specify  any behavioural problem in family");
    }
    if (
      step === PATIENTFORM.FAMILY &&
      toggle.disabilityInTheFamily &&
      family.disabilityInTheFamily.trim() === ""
    ) {
      return toast.warn("Please specify disability in family");
    }

    if (step === PATIENTFORM.ANTENATAL) {
      console.table(antenatal);
    }

    if (step === PATIENTFORM.PRESENT) {
      if (toggle.chronicIllness && present.chronicIllness.trim() === "") {
        return toast.warn("Please specify chronic illness");
      }
      if (toggle.growthFaltering && present.growthFaltering.trim() === "") {
        return toast.warn("Please specify growth faltering");
      }
      if (
        toggle.delayedDevelopmentCognitiveSocial &&
        present.delayedDevelopmentCognitive.trim() === ""
      ) {
        return toast.warn("Please specify delayed development cognitive");
      }
      if (
        toggle.delayedDevelopmentMotor &&
        present.delayedDevelopmentMotor.trim() === ""
      ) {
        return toast.warn("Please specify delayed development motor");
      }
      if (
        toggle.delayedDevelopmentLanguage &&
        present.delayedDevelopmentLanguage.trim() === ""
      ) {
        return toast.warn("Please specify delayed development language");
      }
      if (toggle.atypicalBehaviour && present.atypicalBehaviour.trim() === "") {
        return toast.warn("Please specify atypical behaviour");
      }
      if (toggle.dysmorphism && present.dysmorphism.trim() === "") {
        return toast.warn("Please specify dysmorphism");
      }
      if (
        toggle.anySystemicIllness &&
        present.anySystemicIllness.trim() === ""
      ) {
        return toast.warn("Please specify systemic illness");
      }
    }
    if (childId && parentId) {
      if (step === PATIENTFORM.PRESENT) {
        return handleSubmit();
      }
    }
    if (step === PATIENTFORM.SURVEY) {
      handleSubmit();
    }
    setStep((prevStep) => Math.min(PATIENTFORM.SURVEY, prevStep + 1));
  };

  const decrementStep = () => {
    if (childId && parentId) {
      setStep((prevStep) => Math.max(PATIENTFORM.MATERNAL, prevStep - 1));
    } else {
      setStep((prevStep) => Math.max(PATIENTFORM.CAREGIVER, prevStep - 1));
    }
  };

  const actionLabel = useMemo(() => {
    if (childId && parentId) {
      if (step === PATIENTFORM.PRESENT) {
        return "Submit";
      }
      if (step === PATIENTFORM.SURVEY) {
        return "Submit";
      }
      return "Next";
    }
    if (step === PATIENTFORM.SURVEY) {
      return "Submit";
    }
    return "Next";
  }, [PATIENTFORM.SURVEY, step]);

  const secondaryActionLabel = useMemo(() => {
    if (step === PATIENTFORM.CAREGIVER) {
      return undefined;
    }
    if (step === PATIENTFORM.MATERNAL && childId && parentId) {
      return undefined;
    }
    return "Back";
  }, [PATIENTFORM.CAREGIVER, PATIENTFORM.MATERNAL, childId, parentId, step]);

  const validateCaregiverFields = () => {
    return !haveAccount
      ? cargiver.caregiverFirstName &&
          cargiver.caregiverLastName &&
          cargiver.relationship &&
          cargiver.phoneNumber &&
          cargiver.address &&
          cargiver.password &&
          cargiver.confirmPassword
      : cargiver.caregiverFirstName &&
          cargiver.caregiverLastName &&
          cargiver.relationship &&
          cargiver.phoneNumber &&
          cargiver.address;
  };

  const validatePatientFields = () => {
    return (
      patient.patientFirstName &&
      patient.patientLastName &&
      patient.gender &&
      patient.dateOfBirth
    );
  };

  let bodyContent = (
    <div className={"cargiverFormCard"}>
      <h2 className={"cardHeader"}>Caregiver / Parent Information</h2>
      <select
        style={{ maxWidth: "200px", padding: "8px" }}
        value={language}
        onChange={handleLanguageChange}
      >
        {languages.map((lang) => (
          <option translate="no"
            id={`lang-opt-${lang.code}`}
            key={lang.code}
            value={lang.code}
          >
            {lang.label}
          </option>
        ))}
      </select>
      <div className={"caregiverDiveder parent-caregiverDiveder"}>
        <div>
          <NumberInput
            name={"phoneNumber"}
            label="Phone Number"
            value={cargiver.phoneNumber}
            onChange={handleCaregiverChange}
            required
            slotProps={{
              input: {
                readOnly: accountVerified || accountVerifingLoading,
              },
            }}
          />
        </div>
        <div>
          <input
            type="checkbox"
            onChange={handleAccountChange}
            checked={haveAccount}
          />
          <span>
            I already have a <b>Parent</b> account
          </span>
        </div>
        <TextField
          className="small"
          name="caregiverFirstName"
          label="Caregiver First Name"
          type="text"
          size="small"
          value={cargiver.caregiverFirstName}
          onChange={handleCaregiverChange}
          required
          slotProps={{
            input: {
              readOnly: accountVerified,
            },
          }}
        />
        <TextField
          name="caregiverLastName"
          label="Caregiver Last Name"
          type="text"
          size="small"
          value={cargiver.caregiverLastName}
          onChange={handleCaregiverChange}
          required
          slotProps={{
            input: {
              readOnly: accountVerified,
            },
          }}
        />
        <TextField
          select
          name={"relationship"}
          label="Relationship"
          type={"text"}
          size="small"
          value={cargiver.relationship}
          onChange={handleCaregiverChange}
          required
          slotProps={{
            input: {
              readOnly: accountVerified,
            },
          }}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {relationValues.map((value) => (
            <MenuItem key={value} value={value}>
              {value}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          name={"email"}
          label="Email"
          type={"text"}
          size="small"
          value={cargiver.email}
          onChange={handleCaregiverChange}
          slotProps={{
            input: {
              readOnly: accountVerified,
            },
          }}
        />
        <TextField
          name={"address"}
          type="text"
          size="small"
          value={cargiver.address}
          label={"Address"}
          onChange={handleCaregiverChange}
          required
          slotProps={{
            input: {
              readOnly: accountVerified,
            },
          }}
        />
        {!haveAccount && (
          <>
            <div style={{ position: "relative" }}>
              <TextField
                name={"password"}
                type={!isPasswordVisible ? "password" : "text"}
                size="small"
                value={cargiver.password}
                label={"Password"}
                onChange={handleCaregiverChange}
                required
                sx={{ width: "100%" }}
              />
              <FontAwesomeIcon
                icon={isPasswordVisible ? faEyeSlash : faEye}
                onClick={() => setIsPasswordVisible((prev) => !prev)}
                style={{
                  position: "absolute",
                  right: "8px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#555",
                }}
              />
            </div>
            <div style={{ position: "relative" }}>
              <TextField
                name={"confirmPassword"}
                type={!isConfirmPasswordVisible ? "password" : "text"}
                size="small"
                value={cargiver.confirmPassword}
                label={"Confirm Password"}
                onChange={handleCaregiverChange}
                required
                sx={{ width: "100%" }}
              />
              <FontAwesomeIcon
                icon={isConfirmPasswordVisible ? faEyeSlash : faEye}
                onClick={() => setIsConfirmPasswordVisible((prev) => !prev)}
                style={{
                  position: "absolute",
                  right: "8px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#555",
                }}
              />
            </div>
          </>
        )}
      </div>
      {errorMessage && (
        <p style={{ color: "red", fontSize: "16px" }}>{errorMessage}</p>
      )}
    </div>
  );

  let patientForm = (
    <div className={"cargiverFormCard"}>
      <h2 className={"cardHeader"}>Patient Information</h2>
      <div className={"caregiverDiveder"}>
        <TextField
          name={"patientFirstName"}
          label="Patient First Name"
          value={patient.patientFirstName}
          type={"text"}
          size="small"
          onPaste={(e) => e.preventDefault()}
          onChange={handlePatientChange}
          required
        />
        <TextField
          name={"patientMiddleName"}
          label="Patient Middle Name"
          value={patient.patientMiddleName}
          type={"text"}
          size="small"
          onPaste={(e) => e.preventDefault()}
          className={"requiredLabel"}
          onChange={handlePatientChange}
        />
        <TextField
          name={"patientLastName"}
          label="Patient Last Name"
          type={"text"}
          size="small"
          value={patient.patientLastName}
          onPaste={(e) => e.preventDefault()}
          className={"requiredLabel"}
          onChange={handlePatientChange}
          required
        />
        <div className="calender">
          <BasicDatePicker
            value={patient.dateOfBirth}
            label={"Date of Birth"}
            onChange={handleDateChange}
            required
            maxDate
          />
          {patient.dateOfBirth && (
            <span
              className="clear-calender"
              onClick={() =>
                setPatient((prev) => ({ ...prev, dateOfBirth: null }))
              }
            >
              X
            </span>
          )}
        </div>
        <TextField
          type={"text"}
          size="small"
          select
          name={"gender"}
          label="Gender"
          onChange={handlePatientChange}
          value={patient.gender}
          required
          sx={{
            fontSize: "14px",
            height: "40px",
            backgroundColor: "#3071FF21",
          }}
        >
          {gendersValue.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </div>
    </div>
  );

  let maternalForm = (
    <div className={"cargiverFormCard"}>
      <h2 className={"cardHeader"}>Maternal Information</h2>
      <div className={"caregiverDiveder"}>
        <NumberInput
          name={"maternalAge"}
          label="Mother Age"
          value={maternal.maternalAge}
          onChange={handleMaternalChange}
        />
        <TextField
          type={"text"}
          select
          size="small"
          name={"education"}
          label={"Mother Education"}
          onChange={handleMaternalChange}
          value={maternal.education}
          sx={{ backgroundColor: "#3071FF21" }}
        >
          {maternalEducationValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <NumberInput
          name={"numberOfChildren"}
          label="Number Of Children"
          value={maternal.numberOfChildren}
          onChange={handleMaternalChange}
        />
      </div>
    </div>
  );

  const handleBirthTrauamaChange = (e) => {
    const value = e.target.value;
    if (value === "yes") {
      setToggle((prevToggle) => ({
        ...prevToggle,
        birthTrauma: true,
      }));
      setBirth((prevBirth) => ({
        ...prevBirth,
        birthTrauma: "",
      }));
    } else {
      setToggle((prevToggle) => ({
        ...prevToggle,
        birthTrauma: false,
      }));
      setBirth((prevBirth) => ({
        ...prevBirth,
        birthTrauma: "no",
      }));
    }
  };

  const handleCongenitalAnomalyChange = (e) => {
    const value = e.target.value;
    if (value === "yes") {
      setToggle((prevToggle) => ({
        ...prevToggle,
        isCongenitalAnomaly: true,
      }));
      setBirth((prevBirth) => ({
        ...prevBirth,
        congenitalAnomaly: "",
      }));
    } else {
      setToggle((prevToggle) => ({
        ...prevToggle,
        isCongenitalAnomaly: false,
      }));
      setBirth((prevBirth) => ({
        ...prevBirth,
        congenitalAnomaly: "no",
      }));
    }
  };

  const handleCongenitalAnomalyInputChange = (e) => {
    const value = e.target.value;
    setBirth((prevBirth) => ({
      ...prevBirth,
      congenitalAnomaly: cleanEnglishOnly(value),
    }));
  };

  const handleBirthTraumaInputChange = (e) => {
    const value = e.target.value;
    setBirth((prevBirth) => ({
      ...prevBirth,
      birthTrauma: cleanEnglishOnly(value),
    }));
  };

  let antenatalForm = (
    <div className={"cargiverFormCard"}>
      <h2 className={"cardHeader"}>Antenatal Information</h2>
      <div className={"caregiverDiveder"}>
        <TextField
          type={"text"}
          select
          size="small"
          label={"Mother Nutrition "}
          name={"mothersNutrition"}
          onChange={handleAntenatalChange}
          value={antenatal.mothersNutrition}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {mothersNutritionValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          type={"text"}
          name={"antenatalCheckUps"}
          size="small"
          select
          label={"Antenatal CheckUps"}
          onChange={handleAntenatalChange}
          value={antenatal.antenatalCheckUps}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {antenatalCheckUpsvalues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          type={"text"}
          name={"iron"}
          select
          size="small"
          label={"Iron or Folic Acid "}
          onChange={handleAntenatalChange}
          value={antenatal.iron}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {ironValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          type={"text"}
          select
          size="small"
          name={"injectionTetanusToxoid"}
          onChange={handleAntenatalChange}
          value={antenatal.injectionTetanusToxoid}
          label={"Injection Tetanus Toxoid"}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {injectionTetanusToxoidValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        <FormControl
          size="small"
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          <InputLabel id="tone">Antenatal Illness</InputLabel>
          <Select
            labelId="responsive-care-giving-label"
            id="responsive-car-giving"
            multiple
            value={antenatal.antenatalIllness}
            onChange={(e) => {
              setAntenatal((prev) => ({
                ...prev,
                antenatalIllness: e.target.value,
              }));
            }}
            input={<OutlinedInput label="Antenatal Illness" />}
            renderValue={(selected) => selected.join(", ")}
            MenuProps={MenuProps}
          >
            {antenatalIllnessOptionValues.map((name) => (
              <MenuItem key={name} value={name} sx={{ width: 400 }}>
                <Checkbox checked={antenatal.antenatalIllness.includes(name)} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <div className="calender">
          <BasicDatePicker
            value={antenatal.edd}
            label={"Expected Date of Delivery"}
            onChange={handleEddDateChange}
          />
          {antenatal?.edd && (
            <span
              className="clear-calender"
              onClick={() => setAntenatal((prev) => ({ ...prev, edd: null }))}
            >
              X
            </span>
          )}
        </div>
      </div>
    </div>
  );

  let birthForm = (
    <div className={"cargiverFormCard"}>
      <h2 className={"cardHeader"}>Birth Information</h2>
      <div className={"caregiverDiveder"}>
        <TextField
          type={"text"}
          select
          size="small"
          name={"placeOfDelivery"}
          onChange={handleBirthChange}
          label={"Place Of Delivery"}
          value={birth.placeOfDelivery}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {placeOfDeliveryValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          label={"Mode Of Delivery"}
          size="small"
          select
          type={"text"}
          name={"modeOfDelivery"}
          onChange={handleBirthChange}
          value={birth.modeOfDelivery}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {modeOfDeliveryvalues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          label={"Cried At Birth"}
          type={"text"}
          select
          size="small"
          name={"criedAtBirth"}
          onChange={handleBirthChange}
          value={birth.criedAtBirth}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {criedAtBirthValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <FormControl
          size="small"
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          <InputLabel id="tone">Resuscitation</InputLabel>
          <Select
            labelId="Resuscitation"
            id="Resuscitation"
            multiple
            value={birth.resuscitation}
            onChange={(e) => {
              setBirth((prev) => ({
                ...prev,
                resuscitation: e.target.value,
              }));
            }}
            input={<OutlinedInput label="Resuscitation" />}
            renderValue={(selected) => selected.join(", ")}
            MenuProps={MenuProps}
          >
            {resuscitationValues.map((name) => (
              <MenuItem key={name} value={name} sx={{ width: 400 }}>
                <Checkbox checked={birth.resuscitation.includes(name)} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label={"Congenital Anomaly"}
          type={"text"}
          select
          size="small"
          name={"congenitalAnomaly"}
          onChange={handleCongenitalAnomalyChange}
          value={toggle.isCongenitalAnomaly ? "yes" : birth.congenitalAnomaly}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        {toggle.isCongenitalAnomaly && (
          <TextField
            name={"congenitalAnomaly"}
            label="Specify Congenital Anomaly"
            type={"text"}
            size="small"
            // placeholder={"Specify Congenital Anomaly"}
            className={""}
            onChange={handleCongenitalAnomalyInputChange}
            value={birth.congenitalAnomaly}
          />
        )}
        <NumberInput
          name="birthWeight"
          label="Birth Weight in kg (e.g.,3.50)"
          value={birth.birthWeight}
          onChange={handleBirthChange}
          max={999.99}
    
        />
        <NumberInput
          name="birthLength"
          label="Birth Length in cm (e.g., 50.00)"
          value={birth.birthLength}
          onChange={handleBirthChange}
          max={999.99}
        />
        <NumberInput
          name="birthHeadCircumference"
          label="Birth Head Circumference in cm"
          value={birth.birthHeadCircumference}
          onChange={handleBirthChange}
          max={999.99}
        />
        <NumberInput
          name="gestationalAge"
          label="Gestational Age in weeks"
          value={birth.gestationalAge}
          size="small"
          onChange={handleBirthChange}
          slotProps={{
            input: {
              readOnly: antenatal?.edd,
            },
          }}
        />
        <TextField
          name={"birthTrauma"}
          type={"text"}
          select
          size="small"
          label={"Birth Trauma"}
          value={toggle.birthTrauma ? "yes" : birth.birthTrauma}
          onChange={handleBirthTrauamaChange}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        {toggle.birthTrauma && (
          <TextField
            name={"birthTrauma"}
            type={"text"}
            size="small"
            label={"Specify Birth Trauma"}
            className={""}
            onChange={handleBirthTraumaInputChange}
            value={birth.birthTrauma}
          />
        )}

        <TextField
          name={"others"}
          type={"text"}
          size="small"
          label={"Other birth comments if any"}
          className={""}
          value={birth.others}
          onChange={handleBirthChange}
        />
      </div>
    </div>
  );

  let neonatalForm = (
    <div className={"cargiverFormCard"}>
      <h2 className="cardHeader">Neonatal Period</h2>
      <div className={"caregiverDiveder two-items"}>
        <FormControl
          size="small"
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          <InputLabel id="tone">Neonatal Problems</InputLabel>
          <Select
            labelId="Neonatal Problems"
            id="Neonatal Problems"
            multiple
            value={neontal.neonatalProblems}
            onChange={(e) => {
              setNeonatal((prev) => ({
                ...prev,
                neonatalProblems: e.target.value,
              }));
            }}
            input={<OutlinedInput label="Neonatal Problems" />}
            renderValue={(selected) => selected.join(", ")}
            MenuProps={MenuProps}
          >
            {neonatalProblemsOptionValues.map((name) => (
              <MenuItem key={name} value={name} sx={{ width: 400 }}>
                <Checkbox checked={neontal.neonatalProblems.includes(name)} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label={"Hospitalization"}
          type={"text"}
          select
          size="small"
          name={"hospitalization"}
          onChange={handleNeonatalChange}
          value={neontal.hospitalization}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {hospitalizationValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </div>
    </div>
  );

  const handleAnyHistoryOfIillnessChange = (e) => {
    const value = e.target.value;
    if (value === "yes") {
      setToggle((prevToggle) => ({
        ...prevToggle,
        anyHistoryofIllness: true,
      }));
      setFamily((prevBirth) => ({
        ...prevBirth,
        anyHistoryofIllness: "",
      }));
    } else {
      setToggle((prevToggle) => ({
        ...prevToggle,
        anyHistoryofIllness: false,
      }));
      setFamily((prevBirth) => ({
        ...prevBirth,
        anyHistoryofIllness: "no",
      }));
    }
  };

  const handleAnyBehavProblemChange = (e) => {
    const value = e.target.value;
    if (value === "yes") {
      setToggle((prevToggle) => ({
        ...prevToggle,
        anyBehaviouralProblem: true,
      }));
      setFamily((prevBirth) => ({
        ...prevBirth,
        anyBehaviouralProblem: "",
      }));
    } else {
      setToggle((prevToggle) => ({
        ...prevToggle,
        anyBehaviouralProblem: false,
      }));
      setFamily((prevBirth) => ({
        ...prevBirth,
        anyBehaviouralProblem: "no",
      }));
    }
  };

  const handleAnyDevelopmentChange = (e) => {
    const value = e.target.value;
    if (value === "yes") {
      setToggle((prevToggle) => ({
        ...prevToggle,
        disabilityInTheFamily: true,
      }));
      setFamily((prevBirth) => ({
        ...prevBirth,
        disabilityInTheFamily: "",
      }));
    } else {
      setToggle((prevToggle) => ({
        ...prevToggle,
        disabilityInTheFamily: false,
      }));
      setFamily((prevBirth) => ({
        ...prevBirth,
        disabilityInTheFamily: "no",
      }));
    }
  };

  const handleAnyHistoryOfIillnessInputChange = (e) => {
    const value = e.target.value;
    setFamily((prevBirth) => ({
      ...prevBirth,
      anyHistoryofIllness: cleanEnglishOnly(value),
    }));
  };

  const handleAnyBehavProblemInputChange = (e) => {
    const value = e.target.value;
    setFamily((prevBirth) => ({
      ...prevBirth,
      anyBehaviouralProblem: cleanEnglishOnly(value),
    }));
  };

  const handleDisbailityInFamilyInputChange = (e) => {
    const value = e.target.value;
    setFamily((prevBirth) => ({
      ...prevBirth,
      disabilityInTheFamily: cleanEnglishOnly(value),
    }));
  };

  let familyForm = (
    <div className={"cargiverFormCard"}>
      <h2 className={"cardHeader"}>Family History</h2>
      <div className={"familyDiveder"}>
        <TextField
          type={"text"}
          select
          size="small"
          label={"Any history of illness or death in Sibling ?"}
          name={"anyHistoryofIllness"}
          onChange={handleAnyHistoryOfIillnessChange}
          value={
            toggle.anyHistoryofIllness ? "yes" : family.anyHistoryofIllness
          }
          options={yesNoOptions}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        {toggle.anyHistoryofIllness && (
          <TextField
            name={"anyHistoryofIllness"}
            label="Specify history of illness or death"
            size="small"
            type={"text"}
            className={""}
            value={family.anyHistoryofIllness}
            onChange={handleAnyHistoryOfIillnessInputChange}
          />
        )}
        <TextField
          type={"text"}
          name={"anyBehaviouralProblem"}
          select
          size="small"
          label={"Any behavioural problem in the family?"}
          onChange={handleAnyBehavProblemChange}
          value={
            toggle.anyBehaviouralProblem ? "yes" : family.anyBehaviouralProblem
          }
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        {toggle.anyBehaviouralProblem && (
          <TextField
            name={"anyBehaviouralProblem"}
            label="Specify any behavioural problem in the family"
            type={"text"}
            size="small"
            value={family.anyBehaviouralProblem}
            className={""}
            onChange={handleAnyBehavProblemInputChange}
          />
        )}
        <TextField
          type={"text"}
          name={"disabilityInTheFamily"}
          size="small"
          select
          label={"Any developmental challenge/disability in the family ?"}
          onChange={handleAnyDevelopmentChange}
          value={
            toggle.disabilityInTheFamily ? "yes" : family.disabilityInTheFamily
          }
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        {toggle.disabilityInTheFamily && (
          <TextField
            name={"disabilityInTheFamily"}
            label="Specify any developmental challenge in the family"
            type={"text"}
            size="small"
            // placeholder={
            //   "Specify Any developmental challenge / disability in the family "
            // }
            value={family.disabilityInTheFamily}
            className={""}
            onChange={handleDisbailityInFamilyInputChange}
          />
        )}
      </div>
    </div>
  );

  let feedingForm = (
    <div className={"cargiverFormCard"}>
      <h2 className={"cardHeader"}>Feeding Information</h2>
      <div className={"caregiverDiveder"}>
        <TextField
          name={"breastFeeding"}
          value={feeding.breastFeeding}
          type={"text"}
          select
          size="small"
          label={"Breast Feeding"}
          onChange={handleFeedingChange}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {breastFeedingValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <NumberInput
          name={"noOfFeeds"}
          label="No. of feeds or meals per day"
          value={feeding.noOfFeeds}
          className={""}
          onChange={handleFeedingChange}
        />
        <TextField
          name={"solidFood"}
          value={feeding.solidFood}
          type={"text"}
          select
          size="small"
          label={"Solid Food or Semi-solids "}
          className={""}
          onChange={handleFeedingChange}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {breastFeedingValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </div>
    </div>
  );

  const handleChronicIillnessChange = (e) => {
    const value = e.target.value;
    if (value === "yes") {
      setToggle((prevToggle) => ({
        ...prevToggle,
        chronicIllness: true,
      }));
      setPresent((prevBirth) => ({
        ...prevBirth,
        chronicIllness: "",
      }));
    } else {
      setToggle((prevToggle) => ({
        ...prevToggle,
        chronicIllness: false,
      }));
      setPresent((prevBirth) => ({
        ...prevBirth,
        chronicIllness: "no",
      }));
    }
  };

  const handleGrowthFlateeringChange = (e) => {
    const value = e.target.value;
    if (value === "yes") {
      setToggle((prevToggle) => ({
        ...prevToggle,
        growthFaltering: true,
      }));
      setPresent((prevBirth) => ({
        ...prevBirth,
        growthFaltering: "",
      }));
    } else {
      setToggle((prevToggle) => ({
        ...prevToggle,
        growthFaltering: false,
      }));
      setPresent((prevBirth) => ({
        ...prevBirth,
        growthFaltering: "no",
      }));
    }
  };

  const handleDelayedDevCogChange = (e) => {
    const value = e.target.value;
    if (value === "yes") {
      setToggle((prevToggle) => ({
        ...prevToggle,
        delayedDevelopmentCognitiveSocial: true,
      }));
      setPresent((prevBirth) => ({
        ...prevBirth,
        delayedDevelopmentCognitive: "",
      }));
    } else {
      setToggle((prevToggle) => ({
        ...prevToggle,
        delayedDevelopmentCognitiveSocial: false,
      }));
      setPresent((prevBirth) => ({
        ...prevBirth,
        delayedDevelopmentCognitive: "no",
      }));
    }
  };

  const handleDelayedDevMotorChange = (e) => {
    const value = e.target.value;
    if (value === "yes") {
      setToggle((prevToggle) => ({
        ...prevToggle,
        delayedDevelopmentMotor: true,
      }));
      setPresent((prevBirth) => ({
        ...prevBirth,
        delayedDevelopmentMotor: "",
      }));
    } else {
      setToggle((prevToggle) => ({
        ...prevToggle,
        delayedDevelopmentMotor: false,
      }));
      setPresent((prevBirth) => ({
        ...prevBirth,
        delayedDevelopmentMotor: "no",
      }));
    }
  };

  const handleDealyedDevLangChange = (e) => {
    const value = e.target.value;
    if (value === "yes") {
      setToggle((prevToggle) => ({
        ...prevToggle,
        delayedDevelopmentLanguage: true,
      }));
      setPresent((prevBirth) => ({
        ...prevBirth,
        delayedDevelopmentLanguage: "",
      }));
    } else {
      setToggle((prevToggle) => ({
        ...prevToggle,
        delayedDevelopmentLanguage: false,
      }));
      setPresent((prevBirth) => ({
        ...prevBirth,
        delayedDevelopmentLanguage: "no",
      }));
    }
  };

  const handleAtypicalBehavChange = (e) => {
    const value = e.target.value;
    if (value === "yes") {
      setToggle((prevToggle) => ({
        ...prevToggle,
        atypicalBehaviour: true,
      }));
      setPresent((prevBirth) => ({
        ...prevBirth,
        atypicalBehaviour: "",
      }));
    } else {
      setToggle((prevToggle) => ({
        ...prevToggle,
        atypicalBehaviour: false,
      }));
      setPresent((prevBirth) => ({
        ...prevBirth,
        atypicalBehaviour: "no",
      }));
    }
  };

  const handleDysoChange = (e) => {
    const value = e.target.value;
    if (value === "yes") {
      setToggle((prevToggle) => ({
        ...prevToggle,
        dysmorphism: true,
      }));
      setPresent((prevBirth) => ({
        ...prevBirth,
        dysmorphism: "",
      }));
    } else {
      setToggle((prevToggle) => ({
        ...prevToggle,
        dysmorphism: false,
      }));
      setPresent((prevBirth) => ({
        ...prevBirth,
        dysmorphism: "no",
      }));
    }
  };

  const handleAnySystemIllnessChange = (e) => {
    const value = e.target.value;
    if (value === "yes") {
      setToggle((prevToggle) => ({
        ...prevToggle,
        anySystemicIllness: true,
      }));
      setPresent((prevBirth) => ({
        ...prevBirth,
        anySystemicIllness: "",
      }));
    } else {
      setToggle((prevToggle) => ({
        ...prevToggle,
        anySystemicIllness: false,
      }));
      setPresent((prevBirth) => ({
        ...prevBirth,
        anySystemicIllness: "no",
      }));
    }
  };

  const handleChronicIilnessInputChange = (e) => {
    const value = e.target.value;
    setPresent((prevBirth) => ({
      ...prevBirth,
      chronicIllness: cleanEnglishOnly(value),
    }));
  };

  const handleGrowthFlateringInputChange = (e) => {
    const value = e.target.value;
    setPresent((prevBirth) => ({
      ...prevBirth,
      growthFaltering: cleanEnglishOnly(value),
    }));
  };

  const handleDelayedDevCogInputChange = (e) => {
    const value = e.target.value;
    setPresent((prevBirth) => ({
      ...prevBirth,
      delayedDevelopmentCognitive: cleanEnglishOnly(value),
    }));
  };

  const handleDelayedDevMotorInputChange = (e) => {
    const value = e.target.value;
    setPresent((prevBirth) => ({
      ...prevBirth,
      delayedDevelopmentMotor: cleanEnglishOnly(value),
    }));
  };

  const handleDelayedDevLangInputChange = (e) => {
    const value = e.target.value;
    setPresent((prevBirth) => ({
      ...prevBirth,
      delayedDevelopmentLanguage: cleanEnglishOnly(value),
    }));
  };

  const handleDysoInputChange = (e) => {
    const value = e.target.value;
    setPresent((prevBirth) => ({
      ...prevBirth,
      dysmorphism: cleanEnglishOnly(value),
    }));
  };

  const handleAnySystemIllnessInputChange = (e) => {
    const value = e.target.value;
    setPresent((prevBirth) => ({
      ...prevBirth,
      anySystemicIllness: cleanEnglishOnly(value),
    }));
  };

  let presentForm = (
    <div className={"cargiverFormCard"}>
      <h2 className={"cardHeader"}>Present Health Status</h2>
      <div className={"presentDiveder"}>
        <TextField
          className="text"
          type="text"
          size="small"
          label={
            present.currentAge === "" || present.currentAge === 0
              ? "Actual age in days"
              : "Actual age in months"
          }
          name="currentAge"
          value={
            present.currentAge === "" || present.currentAge === 0
              ? present?.currentAgeInDays + " Days"
              : present?.currentAge
          }
          slotProps={{
            input: {
              readOnly: true,
            },
          }}
        />
        {present?.currentAge <= 24 && (
          <TextField
            name="adjustedAge"
            label={
              (present.gestationalAgeInMonths === "" ||
                present.gestationalAgeInMonths === 0) &&
              (present.gestationalAgeInDays !== "" || present.currentAge === 0)
                ? "Adjusted age in days"
                : "Adjusted age in months"
            }
            size="small"
            value={
              present.gestationalAgeInDays !== ""
                ? //  && present.gestationalAgeInDays !== 0
                  present.gestationalAgeInMonths === "" ||
                  present.gestationalAgeInMonths === 0
                  ? `${present.gestationalAgeInDays} Days`
                  : present.gestationalAgeInMonths
                : "N/A"
            }
            slotProps={{
              input: {
                readOnly: true,
              },
            }}
          />
        )}
        <NumberInput
          label="Current weight in kg (e.g. 3.50)"
          name="currentWeight"
          value={present.currentWeight}
          onChange={handlePresentChange}
          max={999.99}
        />
        <NumberInput
          label="Current length in cm (e.g. 50)"
          name="currentLength"
          value={present.currentLength}
          onChange={handlePresentChange}
          max={999.99}
        />
        <NumberInput
          label="Current head circumference cm"
          name="currentHeadCircumference"
          value={present.currentHeadCircumference}
          onChange={handlePresentChange}
          max={999.99}
        />
      </div>
      <div className={"caregiverDiveder"}>
        <TextField
          className="item"
          label={"Immunization"}
          type={"text"}
          select
          size="small"
          name={"immunization"}
          onChange={handlePresentChange}
          value={present.immunization}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {immunizationValue.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          className="item"
          type={"text"}
          select
          size="small"
          label={"Chronic Illness "}
          name={"chronicIllness"}
          onChange={handleChronicIillnessChange}
          value={toggle.chronicIllness ? "yes" : present.chronicIllness}
          options={yesNoOptions}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        {toggle.chronicIllness && (
          <TextField
            className="item"
            value={present.chronicIllness}
            name={"chronicIllness"}
            type={"text"}
            size="small"
            label="Specify Chronic Illness"
            //   placeholder={"Specify Chronic Illness"}
            onChange={handleChronicIilnessInputChange}
          />
        )}
      </div>
      <div className={"caregiverDiveder two-items"}>
        <TextField
          type={"text"}
          name={"growthFaltering"}
          select
          size="small"
          label={"Growth Faltering"}
          onChange={handleGrowthFlateeringChange}
          value={toggle.growthFaltering ? "yes" : present.growthFaltering}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        {toggle.growthFaltering && (
          <TextField
            name={"growthFaltering"}
            type={"text"}
            size="small"
            label="Specify Growth Faltering"
            //   placeholder={"Specify Growth Faltering"}
            className={""}
            value={present.growthFaltering}
            onChange={handleGrowthFlateringInputChange}
          />
        )}
        <TextField
          type={"text"}
          select
          size="small"
          label={"Delayed Development Cognitive"}
          name={"delayedDevelopmentCognitive"}
          onChange={handleDelayedDevCogChange}
          value={
            toggle.delayedDevelopmentCognitiveSocial
              ? "yes"
              : present.delayedDevelopmentCognitive
          }
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        {toggle.delayedDevelopmentCognitiveSocial && (
          <TextField
            name={"delayedDevelopmentCognitive"}
            type={"text"}
            size="small"
            label="Specify Delayed Development Cognitive"
            //   placeholder={"Specify Delayed Development Cognitive"}
            className={""}
            onChange={handleDelayedDevCogInputChange}
            value={present.delayedDevelopmentCognitive}
          />
        )}
        <TextField
          type={"text"}
          select
          size="small"
          label={"Delayed Development Motor"}
          name={"delayedDevelopmentMotor"}
          onChange={handleDelayedDevMotorChange}
          value={
            toggle.delayedDevelopmentMotor
              ? "yes"
              : present.delayedDevelopmentMotor
          }
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        {toggle.delayedDevelopmentMotor && (
          <TextField
            name={"delayedDevelopmentMotor"}
            type={"text"}
            size="small"
            label="Specify Delayed Development Motor"
            //   placeholder={"Specify Delayed Development Motor"}
            className={""}
            value={present.delayedDevelopmentMotor}
            onChange={handleDelayedDevMotorInputChange}
          />
        )}
        <TextField
          type={"text"}
          size="small"
          select
          label="Delayed Development Language "
          name={"delayedDevelopmentLanguage"}
          onChange={handleDealyedDevLangChange}
          value={
            toggle.delayedDevelopmentLanguage
              ? "yes"
              : present.delayedDevelopmentLanguage
          }
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        {toggle.delayedDevelopmentLanguage && (
          <TextField
            name={"delayedDevelopmentLanguage"}
            type={"text"}
            size="small"
            label="Specify Delayed Development Language"
            //   placeholder={"Specify Delayed Development Language "}
            className={""}
            onChange={handleDelayedDevLangInputChange}
            value={present.delayedDevelopmentLanguage}
          />
        )}
        <TextField
          type={"text"}
          label={"Atypical Behaviour"}
          select
          size="small"
          name={"atypicalBehaviour"}
          onChange={handleAtypicalBehavChange}
          value={toggle.atypicalBehaviour ? "yes" : present.atypicalBehaviour}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        {toggle.atypicalBehaviour && (
          <TextField
            name={"atypicalBehaviour"}
            type={"text"}
            size="small"
            label="Specify Atypical Behaviour"
            // placeholder={"Specify Atypical Behaviour"}
            className={""}
            onChange={handlePresentChange}
            value={present.atypicalBehaviour}
          />
        )}
      </div>
      <div className={"caregiverDiveder"}>
        <TextField
          label={"Convulsions"}
          type={"text"}
          select
          size="small"
          name={"convulsions"}
          onChange={handlePresentChange}
          value={present.convulsions}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          select
          label={"Dysmorphism"}
          size="small"
          type={"text"}
          name={"dysmorphism"}
          onChange={handleDysoChange}
          value={toggle.dysmorphism ? "yes" : present.dysmorphism}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        {toggle.dysmorphism && (
          <TextField
            name={"dysmorphism"}
            type={"text"}
            size="small"
            label="Specify Dysmorphism"
            //   placeholder={"Specify Dysmorphism "}
            className={""}
            onChange={handleDysoInputChange}
            value={present.dysmorphism}
          />
        )}
        <TextField
          type={"text"}
          select
          size="small"
          label={"Any Systemic Illness "}
          name={"anySystemicIllness"}
          onChange={handleAnySystemIllnessChange}
          value={toggle.anySystemicIllness ? "yes" : present.anySystemicIllness}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        {toggle.anySystemicIllness && (
          <TextField
            name={"anySystemicIllness"}
            type={"text"}
            size="small"
            label="Specify Any Systemic Illness"
            //   placeholder={"Specify Any Systemic Illness"}
            className={""}
            onChange={handleAnySystemIllnessInputChange}
            value={present.anySystemicIllness}
          />
        )}
        <TextField
          type="text"
          size="small"
          label="Any other comments"
          name="presentOthers"
          value={present.presentOthers}
          // placeholder="Others"
          onChange={handlePresentChange}
        />
      </div>
    </div>
  );

  const [qrCode, setQrCode] = useState(""); // Store generated QR Code
  const [isQrModalVisible, setQrModalVisible] = useState(false); // Show/hide QR modal

  // Function to validate email

  const handleSubmit = async () => {
    const surveyData = getSurveyData();

    if (!childId && !parentId && !isValidSurvey(surveyData)) {
      toast.warn("Please answer all questions");
      return;
    }

    // setSurvey((prev) => ({
    //   ...prev,
    //   s5: optionlength ? getCommaSeparated() : "",
    // }));

    // Check if all required fields are filled

    const antenatalIllnessValues = antenatal.antenatalIllness;
    const resuscitationValues = birth.resuscitation;
    const neonatalProblemsValues = neontal.neonatalProblems;

    const payload = {
      pediatricianId,
      ...cargiver,
      relationship: capitailzer(cargiver.relationship),
      ...patient,
      ...maternal,
      ...antenatal,
      ...birth,
      ...present,
      parentAlreadyRegistered: haveAccount,
      patientFirstName: patient.patientFirstName.trim(),
      patientMiddleName: patient.patientMiddleName?.trim(),
      patientLastName: patient.patientLastName.trim(),
      ...neontal,
      ...family,
      ...feeding,
      neonatalProblems: neonatalProblemsValues,
      antenatalCheckups: antenatal.antenatalCheckUps,
      resuscitation: resuscitationValues,
      antenatalIllness: antenatalIllnessValues,
      nutrition: antenatal.mothersNutrition,
      dateOfBirth: patient.dateOfBirth
        ? new Date(patient.dateOfBirth).toLocaleDateString("en-CA")
        : null,
      edd: antenatal.edd
        ? new Date(antenatal.edd).toLocaleDateString("en-CA")
        : null,
      ...surveyData,
    };

    console.log("Payload:", payload);
    console.log("firstname: ",payload.patientFirstName, "lastname: ",  payload.patientLastName);
    console.log({ SURVEY: survey });

    try {
      setLoading(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
      let response;
      if (childId && parentId) {
        response = await fetch(
          `${BackendURL}/api/add_patient_by_doctor_via_parent_link?childId=${childId}&parentId=${parentId}&doctorId=${doctorId}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
            credentials: "include",
          }
        );
      } else {
        response = await fetch(`${BackendURL}/api/add_patient_by_parent`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
          credentials: "include",
        });
      }

      const result = await response.json();
      console.log(result);

      if (response.ok) {
        if (childId && parentId) {
          toast.success("Child added successfully to doctor's list");
          return navigate("/parent-profile");
        }
        setLoading(false);
        const qrCodeBase64 = result.qr_code;
        setQrCode(`data:image/png;base64,${qrCodeBase64}`);
        setQrModalVisible(true);
        // toast.success("Patient added successfully");
        toast.success("Patient added successfully");

        setIsChildAdded(true);

        setStep(PATIENTFORM.CAREGIVER);
        setCaregiver(CAREGIVERSTATE);
        setPatient(PATIENTSTATE);
        setMaternal(MATERNALSTATE);
        setAntenatal(ANTENATALSTATE);
        setBirth(BIRTHSTATE);
        setNeonatal(NEONATALSTATE);
        setPresent(PRESENTSTATE);
        setFamily(FAMILYSTATE);
        setFeeding(FEEDINGSTATE);
        setSurvey(SURVEYSTATE);
      } else {
        setLoading(false);
        toast.error(
          result?.message || "An error occurred while adding the patient."
        );
      }
    } catch (error) {
      setLoading(false);
      console.error("Error adding patient:", error);
      toast.error("Failed to add patient. Please try again later.");
    }
  };

  const [selectedOptions, setSelectedOptions] = useState([]);

  const getCommaSeparated = () => selectedOptions.join(", ");
  const optionlength = selectedOptions.length > 0;

  const options = [
    { id: "s5op-1", label: "Pediatrician", value: "Pediatrician" },
    { id: "s5op-2", label: "Books", value: "Books" },
    { id: "s5op-3", label: "Websites", value: "Websites" },
    { id: "s5op-4", label: "Apps", value: "Apps" },
    { id: "s5op-5", label: "Friends", value: "Friends" },
    { id: "s5op-6", label: "None", value: "None" },
  ];

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setSelectedOptions((prev) =>
      checked ? [...prev, value] : prev.filter((val) => val !== value)
    );
  };

  function handleChange(e) {
    const { name, value } = e.target;
    setSurvey((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  const getSurveyData = () => ({
    // s1: survey.s1,
    // s2: survey.s2,
    s3: survey.s3,
    // s4: survey.s4,
    s5: selectedOptions.length > 0 ? selectedOptions.join(", ") : "",
    s6: survey.s6,
  });

  const isValidSurvey = (data) => {
    return Object.values(data).every((val) => val && val.trim() !== "");
  };

  const S1options = [1, 2, 3, 4, 5];
  const S2options = [
    { id: "s2op-1", label: "Never", value: "never", name: "s2" },
    { id: "s2op-2", label: "1-2 Times", value: "1-2", name: "s2" },
    { id: "s2op-3", label: "Weekly", value: "weekly", name: "s2" },
    { id: "s2op-4", label: "Daily", value: "daily", name: "s2" },
  ];

  const suryeyForm = (
    <form className="presurvey">
      <p>Baseline-Survey</p>
      <div className="survey-container">
        <p>Please complete below and click continue Sign-up</p>

        {/* Question 1 */}
        {/* <div className="survey-questiondiv">
          <label htmlFor="s1">1. Stress level monitoring development</label>
          <div className="star-rating">
            {S1options.map((val) => (
              <span
                key={val}
                onClick={() =>
                  handleChange({
                    target: { name: "s1", value: val.toString() },
                  })
                }
                style={{ cursor: "pointer" }}
              >
                <FontAwesomeIcon
                  icon={survey.s1 >= val ? solidStar : regularStar}
                  style={{
                    color: "#f5b301",
                    fontSize: "24px",
                    marginRight: "4px",
                  }}
                />
              </span>
            ))}
          </div>
        </div> */}

        {/* Question 2 */}
        {/* <div className="survey-questiondiv">
          <label htmlFor="s2">
            2. Frequency of checking milestones last month
          </label>
          <div className="survey-options">
            {S2options.map((opt) => (
              <div key={opt.id} className="survey-option">
                <label htmlFor={opt.id}>
                  <input
                    type="radio"
                    id={opt.id}
                    name={opt.name}
                    value={opt.value}
                    checked={survey.s2 === opt.value}
                    onChange={handleChange}
                  />
                  {opt.label}
                </label>
              </div>
            ))}
          </div>
        </div> */}

        {/* Question 3 */}
        <div className="survey-questiondiv">
          <label htmlFor="s3">
            1. I have a good understanding of my child’s developmental
            milestones.
          </label>
          <div className="star-rating">
            {S1options.map((val) => (
              <span
                key={val}
                onClick={() =>
                  handleChange({
                    target: { name: "s3", value: val.toString() },
                  })
                }
                style={{ cursor: "pointer" }}
              >
                <FontAwesomeIcon
                  icon={survey.s3 >= val ? solidStar : regularStar}
                  style={{
                    color: "#f5b301",
                    fontSize: "24px",
                    marginRight: "4px",
                  }}
                />
              </span>
            ))}
          </div>
        </div>

        {/* Question 4 */}
        {/* <div className="survey-questiondiv">
          <label htmlFor="s4">4. Confidence in next steps if delay</label>
          <div className="star-rating">
            {S1options.map((val) => (
              <span
                key={val}
                onClick={() =>
                  handleChange({
                    target: { name: "s4", value: val.toString() },
                  })
                }
                style={{ cursor: "pointer" }}
              >
                <FontAwesomeIcon
                  icon={survey.s4 >= val ? solidStar : regularStar}
                  style={{
                    color: "#f5b301",
                    fontSize: "24px",
                    marginRight: "4px",
                  }}
                />
              </span>
            ))}
          </div>
        </div> */}

        {/* Question 5 */}
        <div className="survey-questiondiv">
          <label htmlFor="s5">
            2. Sources I rely on for developmental milestone information (choose
            all that apply)
          </label>
          <div className="survey-options">
            {options.map((opt) => (
              <div key={opt.id} className="survey-option">
                <label htmlFor={opt.id}>
                  <input
                    type="checkbox"
                    id={opt.id}
                    name="options"
                    value={opt.value}
                    checked={selectedOptions.includes(opt.value)}
                    onChange={handleCheckboxChange}
                  />
                  {opt.label}
                </label>
              </div>
            ))}
          </div>
        </div>

        {/* Question 6 */}
        <div className="survey-questiondiv survey-s6">
          <label htmlFor="s6">3. My biggest worry about my child is</label>
          <textarea
            name="s6"
            id="s6"
            onChange={handleChange}
            value={survey.s6}
          ></textarea>
        </div>
      </div>
    </form>
  );

  return (
    <div className="patient-profile child-form">
      <Loader isLoading={loading} />
      {!isChildAdded && (
        <h2
          style={{ textAlign: "center", width: "100%", marginBottom: "20px" }}
        >
          New Patient Questionnaire
        </h2>
      )}
      <>
        {/* <h2>Patient Management System</h2> */}
        {!isChildAdded && step === PATIENTFORM.CAREGIVER && bodyContent}
        {!isChildAdded && step === PATIENTFORM.PATIENT && patientForm}
        {!isChildAdded && step === PATIENTFORM.MATERNAL && maternalForm}
        {!isChildAdded && step === PATIENTFORM.ANTENATAL && antenatalForm}
        {!isChildAdded && step === PATIENTFORM.BIRTH && birthForm}
        {!isChildAdded && step === PATIENTFORM.NEONATAL && neonatalForm}
        {!isChildAdded && step === PATIENTFORM.FAMILY && familyForm}
        {!isChildAdded && step === PATIENTFORM.FEEDING && feedingForm}
        {!isChildAdded && step === PATIENTFORM.PRESENT && presentForm}
        {!isChildAdded && step === PATIENTFORM.SURVEY && suryeyForm}

        <div className={"actionButtons"}>
          {!isChildAdded && secondaryActionLabel && (
            <button
              type="button"
              className={"secondaryActionButton"}
              onClick={decrementStep}
            >
              {secondaryActionLabel}
            </button>
          )}
          {!isChildAdded && actionLabel && (
            <button
              className={"actionButton"}
              onClick={incrementStep}
              type="button"
            >
              {actionLabel}
            </button>
          )}
        </div>
      </>
      {isChildAdded && (
        <div className="child-added">
          <h3>Thankyou for submitting New Patient Questionnaire.</h3>
          <p>
            {/* <b>1. </b> Download the QR code and share with your pediatrician */}
            <b>1. </b> Information has been shared with your Provider. Please
            consult your Provider.
          </p>
        </div>
      )}
      {/* QR Code Modal */}
      {/* {isQrModalVisible && (
        <div className="parent-qr-modal">
          <div className="qr-modal-content">
            <button id="download-qr">
              <a
                href={qrCode}
                download={
                  qrCode.length > 30 ? qrCode.substring(25, 30) : qrCode
                }
              >
                <FontAwesomeIcon
                  icon={faCloudArrowDown}
                  width={50}
                  height={50}
                  size="2x"
                />
              </a>
            </button>
            <h3>QR Code</h3>
            <img src={qrCode} width={256} height={256} alt={"qr-code"} />
          </div>
        </div>
      )} */}
      {isChildAdded && (
        <div className="step-2">
          {/* <p>
            <b>2. </b>Visit the webpage{" "}
            <b>
              <a
                href="https://smile2steps.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                smile2steps.com
              </a>
            </b>
          </p>
          <p>
            <b>3. </b>
            Click <strong>"Get Started"</strong> and Sign-up as Parent to see
            complete health record of your child.
          </p> */}
          <b>2. </b>
          <CountdownMessage
            message="You are being redirected to  Parent Login Page in"
            style={{ color: "black", fontSize: "20px" }}
          />
          <span>
            <Link to={"/parent-login"}>Login</Link>
          </span>
        </div>
      )}
    </div>
  );
};

export default ParentAddChildForm;